import PromoBYDSealion7 from "../../../images/promo/aug26/PromoBYDSealion7.png";
import PromoBYDSealion7Mobile from "../../../images/promo/aug26/PromoBYDSealion7Mobile.png";
import PromoBYDSealion8 from "../../../images/promo/aug26/PromoBYDSealion8.png";
import PromoBYDSealion8Mobile from "../../../images/promo/aug26/PromoBYDSealion8Mobile.png";
import PromoTeslaY from "../../../images/promo/aug26/PromoTeslaY.png";
import PromoTeslaYMobile from "../../../images/promo/aug26/PromoTeslaYMobile.png";
import PromoZeekr7X from "../../../images/promo/aug26/PromoZeekr7X.png";
import PromoZeekr7XMobile from "../../../images/promo/aug26/PromoZeekr7XMobile.png";
import PromoJaecooJ5 from "../../../images/promo/aug26/PromoJaecooJ5.png";
import PromoJaecooJ5Mobile from "../../../images/promo/aug26/PromoJaecooJ5Mobile.png";
import PromoPolestar4 from "../../../images/promo/aug26/PromoPolestar4.png";
import PromoPolestar4Mobile from "../../../images/promo/aug26/PromoPolestar4Mobile.png";
import PromoMercedes from "../../../images/promo/aug26/PromoMercedes.png";
import PromoMercedesMobile from "../../../images/promo/aug26/PromoMercedesMobile.png";

const dataSlider = (hidePartnered) => [
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: true,
        hideBanner: hidePartnered, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        fromText: "from",
        priceDollar: "",
        priceCents: "",
        period: "",
        priceNote: "",
        disclaimerText: "",
        image: "",
        imageMobile: "",
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Drive Away Deal",
        vehicleTitle: "BYD Sealion 7 Premium",
        vehicleSubTitle:
            "Free on-road costs for orders placed between 1st August to 30th September 2026, and delivered by 31st October 2026!",
        fromText: "from",
        priceDollar: "195",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Offer available on new vehicles (NSW, $100k salary, 15k km/yr). Excludes metallic paint.",
        termsLinkUrl: "",
        image: PromoBYDSealion7,
        imageMobile: PromoBYDSealion7Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "$2,000 Cashback",
        vehicleTitle: "BYD Sealion 8 Dynamic AWD & Premium AWD",
        vehicleSubTitle:
            "$2,000 cashback for orders placed between 1st August to 30th September 2026, and delivered by 31st October 2026!",
        fromText: "from",
        priceDollar: "291",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Offer available on new vehicles (NSW, $100k salary, 15k km/yr). Cashback paid via EFT post-delivery.",
        termsLinkUrl: "",
        image: PromoBYDSealion8,
        imageMobile: PromoBYDSealion8Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Zeekr 7X",
        vehicleSubTitle: "",
        fromText: "from",
        priceDollar: "219",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Weekly price assumes a 5 year lease, a driver based in NSW with an annual pre-tax salary of $100,000, and car running costs based on 15,000km driven per year.",
        termsLinkUrl: "",
        image: PromoZeekr7X,
        imageMobile: PromoZeekr7XMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Tesla Model Y Premium RWD",
        vehicleSubTitle: "",
        fromText: "from",
        priceDollar: "219",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Weekly price assumes a 5 year lease (NSW, $100k salary, 15k km/yr).",
        termsLinkUrl: "",
        image: PromoTeslaY,
        imageMobile: PromoTeslaYMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "10% Fleet Discount",
        vehicleTitle: "Jaecoo 5 ICE Summit FWD",
        vehicleSubTitle:
            "10% discount for orders placed between 1st July to 30th September 2026!",
        fromText: "from",
        priceDollar: "152",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Offer available on new vehicles (NSW, $100k salary, 15k km/yr). Metallic paint extra ($545.45).",
        termsLinkUrl: "",
        image: PromoJaecooJ5,
        imageMobile: PromoJaecooJ5Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Partner Pricing",
        vehicleTitle: "Polestar 4 LRSM",
        vehicleSubTitle:
            "Special partner pricing for orders placed between 1st August to 30th September 2026, and delivered by 31st December 2026!",
        fromText: "now",
        priceDollar: "246",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Offer available on new vehicles (NSW, $100k salary, 15k km/yr). Pre-configured stock only.",
        termsLinkUrl: "",
        image: PromoPolestar4,
        imageMobile: PromoPolestar4Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Q3 Mercedes Offers",
        vehicleTitle: "Mercedes-Benz Range",
        vehicleSubTitle:
            "Exclusive drive away deals, complimentary option upgrades, and up to 12% off select models!",
        fromText: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        priceNote: "Special Pricing Available*",
        disclaimerText:
            "* Offer available on new 2024/2025 built vehicles ordered by 30th September 2026 and delivered by 31st October 2026.",
        termsLinkUrl: "",
        image: PromoMercedes,
        imageMobile: PromoMercedesMobile,
    },
];

export default dataSlider;
